"use client";

import { memo } from "react";
import { useForm } from "react-hook-form";
import { Search } from "lucide-react";
import FormInputField from "@/components/custom-form/FormInputField";
import FormSelectField from "@/components/custom-form/FormSelectField";
import { discoverCategoryOptions } from "../search.modules.type";

const DiscoverFields = () => {
  const { control } = useForm({
    defaultValues: {
      explore: "",
      category: "",
    },
  });

  return (
    <>
      <div className="flex-1 min-w-0">
        <FormInputField
          name="explore"
          control={control}
          placeholder="What do you want to explore?"
          leadingIcon={<Search className="size-4 text-muted-foreground" />}
          rounded="full"
        />
      </div>

      <div className="flex-1 min-w-0">
        <FormSelectField
          name="category"
          control={control}
          placeholder="Select Category (Optional)"
          options={discoverCategoryOptions}
        />
      </div>
    </>
  );
};

export default memo(DiscoverFields);
